
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Avantages et inconvénients de Woocommerce par rapport à Shopify",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Woocommerce et Shopify sont les deux plateformes de e-commerce les plus populaires au monde. Cet article vous aidera à choisir celle qui vous convient le mieux.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Avantages et inconvénients de Woocommerce par rapport à Shopify",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Woocommerce et Shopify sont les deux plateformes de e-commerce les plus populaires au monde. Cet article vous aidera à choisir celle qui vous convient le mieux.",
        },
      ],
    };
  },
};
